import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
import { EntCitizenship } from "../../../models/citizenship/citizenship";
import { EntInitialFilter } from "../../../models/filters/initialFilter";

export const citizenshipApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getCitizenshipList: builder.query<ResponseDataGet<EntCitizenship>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${Paths.handbooks.citizenship}/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),
  }),
  overrideExisting: false,
});

export const { useLazyGetCitizenshipListQuery } = citizenshipApi;
